import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  type SaveSystemSettingCommand,
  type SaveSystemSettingCommandResult,
  postSystemSaveSystemSetting,
} from "Infrastructure/Api/Api";
import { systemSettingKeys } from "Api/Queries/System/useGetSystemSettingQuery";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useSaveSystemSettingMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation<
    SaveSystemSettingCommandResult,
    Error,
    SaveSystemSettingCommand
  >({
    mutationFn: async (data) => {
      const response = await postSystemSaveSystemSetting(data);
      if (response.status >= 400 || response.status === 0) {
        throw response;
      }
      return response.data as SaveSystemSettingCommandResult;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: systemSettingKeys.byType(variables.type),
      });
      onSuccess?.();
    },
    onError,
  });
};
